"use client";
import { useEffect } from "react";

type NewsElementProps = {
  newsId: string
};

export function NewsiFrame(
  {
    newsId,
  }: NewsElementProps) {


  useEffect(() => {
    const adjustIframeHeight = () => {
      const otherElementsHeight = 290; // Height of other page elements in pixels
      const availableHeight = window.innerHeight - otherElementsHeight;
      const iframe = document.getElementById(newsId);
      if (iframe) {
        iframe.style.height = `${availableHeight}px`;
      }
    };
    // Adjust height on load
    adjustIframeHeight();
    // Adjust height on window resize
    window.addEventListener('resize', adjustIframeHeight);
    // Cleanup
    return () => window.removeEventListener('resize', adjustIframeHeight);
  }, [newsId]);
  
  return (
    <iframe id={newsId} src={`https://www.kicker.de/${newsId}/artikel#iphone`} style={{ width: '100%' }}  />
  );
}
